import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class AttributionTextItemConfiguration {
    /**
     * ID
     */
    @JsonProperty()
    declare id: string;

    /**
     * The attribution text.
     */
    @JsonProperty()
    declare text: string;
    /**
     * The link title.
     */
    @JsonProperty()
    declare title?: string;
    /**
     * The url for a link.
     */
    @JsonProperty()
    declare url: string;

    constructor() {}
}

@JsonObject()
export class AttributionConfiguration {
    /**
     * The widget's default CSS icon class.
     *
     * @deprecated since 4.27. Use {@link module:esri/widgets/Attribution#icon icon} instead.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Attribution.html#iconClass)
     */
    @JsonProperty()
    declare iconClass: string;
    /**
     * Text used to split attribution by [layers](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-Layer.html)
     *
     * @default |
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Attribution.html#itemDelimiter)
     */
    @JsonProperty()
    declare itemDelimiter: string;

    /**
     *  *Geo.js Property*
     * Delimiter for text items
     */
    @JsonProperty()
    declare textDelimiter: string;

    /**
     *  *Geo.js Property*
     * Text items
     */
    @JsonProperty()
    declare textItems: AttributionTextItemConfiguration[];
    /**
     * A reference to the [MapView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html) or [SceneView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-SceneView.html).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Attribution.html#view)
     */
    // @JsonProperty()
    // declare view?: (MapViewProperties & { type: "2d" }) | (SceneViewProperties & { type: "3d" });
    /**
     * The view model for this widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Attribution.html#viewModel)
     */
    // @JsonProperty()
    // declare viewModel?: AttributionViewModelProperties;

    constructor() {}
}
